

























































































import { Component, Mixins, Vue } from "vue-property-decorator";
import { getState, getRedirectURL } from "@/apis";

import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import InputSerial from "@/components/InputSerial.vue";
import ProgressCircular from "@/components/ProgressCircular.vue";
import PopupDialog from "@/components/PopupDialog.vue";
import ExpansionPanels from "@/components/ExpansionPanels.vue";
import SettingMixin from "@/mixins/settingMixin";
import Overlay from "@/components/Overlay.vue";

import configs from "@/configs";
import { Config } from "@/shims-configs";

import {
  URL_PARAM_CP_ID,
  URL_PARAM_SERIAL_CODE,
  URL_PARAM_STATE,
  URL_PARAM_TRAN_SRC,
} from "@/utils/url";
import { AxiosResponse } from "axios";

@Component({
  components: {
    ContainImage,
    ExternalLink,
    InputSerial,
    ImageButton,
    PopupDialog,
    ExpansionPanels,
    ProgressCircular,
    Overlay,
  },
})
export default class Campaign extends Mixins(Vue, SettingMixin) {
  valid = false;
  mappingToken = "";
  inputSerialCode = "";
  serialCodelength = 14;
  campaignState = "";

  get canCollect(): boolean {
    return this.campaignState === "open";
  }

  get redirectCode(): string {
    if (window.location.host.indexOf("dev") != -1)
      return this.config.redirector.code.dev;
    if (window.location.host.indexOf("stg") != -1)
      return this.config.redirector.code.stg;
    return this.config.redirector.code.prd;
  }

  get config(): Config {
    return configs;
  }
  get participateText(): string {
    return this.config.participateText;
  }
  get participateStyle(): string {
    return (
      this.configStyle + "display: block; margin: 20px; text-align: center;"
    );
  }

  get bannerMain(): string {
    return this.config.imageName.campaign?.bannerMain
      ? `./images/campaign/${this.config.imageName.campaign.bannerMain}`
      : "";
  }
  get bannerDesc(): string {
    return this.config.imageName.campaign?.bannerDesc
      ? `./images/campaign/${this.config.imageName.campaign.bannerDesc}`
      : "";
  }
  get triangle(): string {
    return this.config.imageName.campaign?.triangle
      ? `./images/campaign/${this.config.imageName.campaign.triangle}`
      : "";
  }
  get buttonLINE(): string {
    return this.config.imageName.campaign?.buttonSelectLINE
      ? `./images/campaign/${this.config.imageName.campaign.buttonSelectLINE}`
      : "";
  }
  get buttonLogin(): string {
    return this.config.imageName.campaign?.buttonLogin
      ? `./images/campaign/${this.config.imageName.campaign.buttonLogin}`
      : "";
  }
  get invalidSerialCodeSrc(): string {
    return this.config.imageName.campaign?.popupInvalidSerialCode
      ? `./images/campaign/${this.config.imageName.campaign.popupInvalidSerialCode}`
      : "";
  }
  get popupClose(): string {
    return this.config.imageName.campaign?.popupClose
      ? `./images/campaign/${this.config.imageName.campaign.popupClose}`
      : "";
  }
  get products(): string {
    return this.config.imageName.campaign?.products
      ? `./images/campaign/${this.config.imageName.campaign.products}`
      : "";
  }
  get participate(): string {
    return this.config.imageName.campaign?.participate
      ? `./images/campaign/${this.config.imageName.campaign.participate}`
      : "";
  }

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: void | AxiosResponse<any> = await getState(
      this.campaignId
    ).catch(() => {
      this.routerPushSystemErrorPage();
    });
    if (!res) return;
    this.campaignState = res.data.state;
  }

  async created(): Promise<void> {
    this.inputSerialCode = this.serialCode;
  }

  onChange(val: string): void {
    this.inputSerialCode = val;
  }

  async onClickCollectCharge(): Promise<void> {
    if (this.inputSerialCode.length !== this.serialCodelength) {
      this.showPopupDialog(this.invalidSerialCodeSrc);
      return;
    }

    this.refs.progressCircular.showProgress();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: void | AxiosResponse<any> = await getState(
      this.campaignId
    ).catch(() => {
      this.routerPushSystemErrorPage();
    });

    if (!res) return;

    // 期間外 ポップアップ
    if (res.data.state !== "open" && res.data.state !== "open_collect_end") {
      this.routerPushExpiredPage(res.data.state);
      return;
    }

    this.pushWithTransition(() => {
      // リダイレクタ
      location.href = getRedirectURL(
        this.redirectCode,
        this.campaignId,
        this.inputSerialCode,
        this.transitionSrc
      );
    });

    setTimeout(() => {
      this.refs.progressCircular.hiddenProgress();
    }, 1500);
  }

  onClickReqest(): void {
    this.pushWithTransition(() => {
      location.href = getRedirectURL(
        this.redirectCode,
        this.campaignId,
        "",
        this.transitionSrc
      );
    });
  }

  routerPushChargeExpiredPage(state: string): void {
    this.$router.push({
      name: "Expired",
      query: {
        [URL_PARAM_CP_ID]: this.campaignId,
        [URL_PARAM_SERIAL_CODE]: this.inputSerialCode,
        [URL_PARAM_STATE]: state,
        [URL_PARAM_TRAN_SRC]: this.transitionSrc,
      },
    });
  }
  routerPushSystemErrorPage(): void {
    this.$router.push({
      name: "SystemError",
      query: {
        [URL_PARAM_TRAN_SRC]: this.transitionSrc,
      },
    });
  }
  showPopupDialog(imageSrc: string): void {
    this.refs.popupDialog.show(imageSrc);
  }
  closedPopupDialog(): void {
    if (this.state === "") return;

    if (this.state === "teaser") {
      this.routerPushChargeExpiredPage("teaser");
      return;
    } else {
      this.routerPushChargeExpiredPage("closed");
      return;
    }
  }
}
